import React, { useState, useRef, useEffect } from 'react';

// Combobox con filtro por texto: reemplaza un <select> nativo cuando la
// lista de opciones es larga (departamentos, puestos, supervisores,
// direcciones...) y hacer scroll para encontrar la opción correcta es
// incómodo. Se escribe para filtrar, se hace clic para seleccionar.
const SearchableSelect = ({
  value,
  onChange,
  options,               // [{ id, label }]
  placeholder = 'Buscar...',
  emptyLabel = '-- Sin asignar --',
  allowEmpty = true,
  disabled = false,
  inputStyle = {},
  dropdownStyle = {},
}) => {
  const [open, setOpen]   = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  const selected = options.find(o => String(o.id) === String(value));

  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setQuery('');
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const q = query.trim().toLowerCase();
  const filtered = q ? options.filter(o => (o.label || '').toLowerCase().includes(q)) : options;

  const pick = (id) => {
    onChange(id == null ? '' : String(id));
    setOpen(false);
    setQuery('');
  };

  return (
    <div ref={ref} style={{ position: 'relative', width: '100%' }}>
      <input
        type="text"
        disabled={disabled}
        value={open ? query : (selected ? selected.label : '')}
        onChange={e => { setQuery(e.target.value); if (!open) setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={selected ? selected.label : placeholder}
        autoComplete="off"
        style={{ cursor: disabled ? 'not-allowed' : 'text', ...inputStyle }}
      />
      {open && !disabled && (
        <div
          style={{
            position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4,
            background: '#fff', border: '1px solid #E2E8F0', borderRadius: 8,
            maxHeight: 240, overflowY: 'auto', zIndex: 60,
            boxShadow: '0 10px 30px rgba(0,0,0,.14)',
            ...dropdownStyle,
          }}
        >
          {allowEmpty && (
            <div
              onMouseDown={() => pick('')}
              style={{ padding: '8px 12px', cursor: 'pointer', fontStyle: 'italic', color: '#64748B', fontSize: '.85rem' }}
              onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              {emptyLabel}
            </div>
          )}
          {filtered.length === 0 && (
            <div style={{ padding: '8px 12px', color: '#94A3B8', fontSize: '.85rem' }}>Sin resultados</div>
          )}
          {filtered.map(o => (
            <div
              key={o.id}
              onMouseDown={() => pick(o.id)}
              style={{
                padding: '8px 12px', cursor: 'pointer', fontSize: '.85rem',
                background: String(o.id) === String(value) ? '#EFF6FF' : 'transparent',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#F8FAFC'}
              onMouseLeave={e => e.currentTarget.style.background = String(o.id) === String(value) ? '#EFF6FF' : 'transparent'}
            >
              {o.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchableSelect;
